import { supabase } from '@/config/supabase'

export interface AsaasLookupResult {
    empresa: 'ACSM' | 'MULTIVEICULAR' | null
    customer: {
        id: string
        name: string
        cpfCnpj: string
        email?: string
        mobilePhone?: string
        dateCreated: string
    } | null
    foundInACSM: boolean
    foundInMultiveicular: boolean
    acsmCustomer: object | null
    multiveicularCustomer: object | null
}

export const asaasService = {
    /**
     * Busca o customer nas duas contas Asaas via Edge Function.
     * Aplica regra: ACSM > MULTIVEICULAR.
     * Se `associado_id` for passado, salva asaas_customer_id + asaas_empresa no banco.
     */
    async lookupCustomer(cpf: string, associado_id?: string): Promise<AsaasLookupResult> {
        const { data, error } = await supabase.functions.invoke('asaas-lookup', {
            body: { cpf, associado_id },
        })

        if (error) throw error
        return data as AsaasLookupResult
    },

    /**
     * Busca cobranças dos últimos 3 meses do Asaas, faz match com a placa,
     * salva em veic_faturas e atualiza o status do associado/contrato.
     * Se `associado_id` for omitido, processa TODOS.
     */
    async syncCharges(associado_id?: string): Promise<{ processed: number; errors: number }> {
        const { data, error } = await supabase.functions.invoke('asaas-sync-charges', {
            body: associado_id ? { associado_id } : {},
        })
        if (error) throw error
        return data
    },
}
